// extracted by mini-css-extract-plugin
export default {"header":"Header_header__O3oaW","badge":"Header_badge__HYhDI","site-page-header":"Header_site-page-header__j3eDA"};